import {Component, Input, OnInit} from '@angular/core';
import {ModalService} from "../../services/modal.service";
import {IDocument} from "../../interfaces/document.definition";


@Component({
  selector: 'nv-spine-button',
  templateUrl: './nv-spine-button.component.html',
  styles: []
})
export class NvSpineButtonComponent implements OnInit {
  private _document:IDocument;

  @Input()
  set document(v:IDocument) {
    this._document = v;
  }

  get document():IDocument {
    return this._document;
  }


  constructor(private modalService:ModalService) { }


  onClick() {
    this.modalService.showSpineUpload(this.document);
  }


  ngOnInit() {
    // got document -> reload
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-spine/nv-spine-button.component.ts